import { all, takeLatest, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { retrieveFromLocalStorage } from '../../utils/util';

import {
  requestViewNotifications,
  requestAcknowledgeNotification,
  requestAcknowledgeNotificationsForChat,
} from './notification.actions';
import {
  getViewNotificationsRequest,
  getAcknowledgeNotificationRequest,
  getAcknowledgeNotificationsForChatRequest,
} from './notification.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setNotifications } from '../../slices/party/party.slice';
import { requestRetrieveShortcuts } from '../system-user/system-user.actions';

export function* performViewNotificationsRequest({ payload }) {
  const { receiverExternalReference, onSuccess } = payload;

  try {
    const [endpoint, options] = getViewNotificationsRequest({ receiverExternalReference });

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(setNotifications(data.notificationVOs));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewNotificationsRequest() {
  yield takeLatest(requestViewNotifications.type, performViewNotificationsRequest);
}

export function* performAcknowledgeNotificationRequest({ payload }) {
  const { externalReference, onSuccess } = payload;

  try {
    yield put(addSpinner('Acknowledging Notification'));

    const [endpoint, options] = getAcknowledgeNotificationRequest(externalReference);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Acknowledging Notification'));
  }
}

export function* watchForAcknowledgeNotificationRequest() {
  yield takeLatest(requestAcknowledgeNotification.type, performAcknowledgeNotificationRequest);
}

export function* performAcknowledgeNotificationsForChatRequest({ payload }) {
  const { chatExternalReference, onSuccess } = payload;

  try {
    yield put(addSpinner('Acknowledging Notifications'));

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');
    const [endpoint, options] = getAcknowledgeNotificationsForChatRequest({
      personExternalReference,
      conversationExternalReference: chatExternalReference,
    });

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(requestViewNotifications({ receiverExternalReference: personExternalReference }));
    yield put(requestRetrieveShortcuts());
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Acknowledging Notifications'));
  }
}

export function* watchForAcknowledgeNotificationsForChatRequest() {
  yield takeLatest(requestAcknowledgeNotificationsForChat.type, performAcknowledgeNotificationsForChatRequest);
}

export default function* notificationSaga() {
  yield all([
    watchForViewNotificationsRequest(),
    watchForAcknowledgeNotificationRequest(),
    watchForAcknowledgeNotificationsForChatRequest(),
  ]);
}
